import { createEntityCard } from './entity-card.js';
import { createEntityChoice } from './entity-choice.js';
import { createEntityList } from './entity-list.js';
import { createUpdateProposal } from './update-proposal.js';
import { createUnsupportedBlock } from './unsupported-block.js';
import { isSheetPageBlock } from '../clarification-sheet.js';

/**
 * @param {Object} block
 * @param {Object} options
 * @param {boolean} [options.choiceResolved]
 * @param {function(string): void} [options.onChoiceSelect]
 * @returns {HTMLElement|null}
 */
export function renderBlock(block, options = {}) {
  if (!block || typeof block.type !== 'string') {
    return createUnsupportedBlock('(missing)');
  }

  if (block.type === 'entity_card') {
    return createEntityCard(block);
  }

  if (block.type === 'entity_choice') {
    if (isSheetPageBlock(block)) return null;
    return createEntityChoice(block, {
      resolved: options.choiceResolved,
      onSelect: options.onChoiceSelect,
    });
  }

  if (block.type === 'entity_list') {
    return createEntityList(block, options);
  }

  if (block.type === 'update_proposal') {
    return createUpdateProposal(block, options);
  }

  return createUnsupportedBlock(block.type);
}
